import React from "react";
import { useLocation } from "react-router-dom";

// core components
import Wizard from "components/Wizard/Wizard.js";
import GridContainer from "components/Grid/GridContainer.js";
import GridItem from "components/Grid/GridItem.js";

import Step1 from "./WizardSteps/Step1.js";
import Step2 from "./WizardSteps/Step2.js";
import Step3 from "./WizardSteps/Step3.js";

export default function WizardView() {
  const location = useLocation();
  const query = new URLSearchParams(location.search);
  const referralCodeFromURL = query.get("ref") || "";

  //   console.log("REF:", referralCodeFromURL);

  return (
    <GridContainer justify="center">
      <GridItem xs={12} sm={8}>
        <Wizard
          validate
          steps={[
            {
              stepName: "About",
              stepComponent: Step1,
              stepId: "about",
              stepProps: { referralCodeFromURL }, // ✅ pass it here
            },
            { stepName: "Contacts", stepComponent: Step2, stepId: "account" },
            { stepName: "Security", stepComponent: Step3, stepId: "address" },
          ]}
          title="Create your account"
          subtitle="This information will let us know more about you."
          finishButtonClick={(e) => console.log(e)}
        />
      </GridItem>
    </GridContainer>
  );
}
